const store = Object.create(null);

export const setEnv = envObject => {
  const upperCasedEnvObject = {};
  Object.keys(envObject).forEach(
    key => (upperCasedEnvObject[key.toUpperCase()] = envObject[key])
  );

  Object.assign(store, upperCasedEnvObject);
};

export const getEnv = () => {
  return store;
};

export const clearEnv = () => {
  // You normally don't need this function in production. Useful for testing.
  // Tree shaking + uglify will remove this if we're not using it in the bundle
  Object.keys(store).forEach(key => delete store[key]);
  return true;
};

const env = key => {
  const upperCasedKey = key.toUpperCase();
  if (
    process.env.NODE_ENV !== "production" &&
    store[upperCasedKey] === undefined &&
    upperCasedKey !== "AUTH_TOKEN" &&
    upperCasedKey !== "AUTH_METHOD" &&
    upperCasedKey !== "HY_JWT_TOKEN" &&
    upperCasedKey !== "AUTHENTICATION_DATA" &&
    upperCasedKey !== "LOGGING_ENABLED" &&
    upperCasedKey !== "OAUTH_REFRESH_TOKEN"
  ) {
    throw new Error(`ENV store does not have key: ${upperCasedKey} set`);
  }
  return store[upperCasedKey];
};

export const isProd = () => process.env.NODE_ENV === "production";
export const isTest = () => process.env.NODE_ENV === "test";

export default env;
